'use strict';

var SESSION_TIMEOUT_MODAL_ID = '#sessionTimeoutModal';
var SIGNIN_MODAL_ID = '#signinModal';
var COUNTDOWN_TIMER_ID = '#countdowntimer';
var LAST_ACTIVITY_KEY = 'lastActivity';

module.exports = function () {
    if ($("#loggedInStatus").val() === 'true') {
        var sessionTimeoutTime = parseInt($("#logoutWarningTime").val()) * 1000;
        var autoLogoutInterval;
        var logoutWarningInterval;

        // shows session session timeout modal and after xx secs logout customer and shows signin modal
        function showSessionTimeoutModal() {
            if (!$(SESSION_TIMEOUT_MODAL_ID).is(':visible') && !$(SIGNIN_MODAL_ID).is(':visible')) {
                $(COUNTDOWN_TIMER_ID).html(parseInt($("#autoLogoutTime").val()));
                $(SESSION_TIMEOUT_MODAL_ID).modal({keyboard: false, backdrop: 'static'});

                var timeleft = parseInt($("#autoLogoutTime").val());
                autoLogoutInterval = setInterval(function(){
                    timeleft--;
                    if ($(COUNTDOWN_TIMER_ID).length) {
                        $(COUNTDOWN_TIMER_ID).html(timeleft);
                    }
                    if (timeleft <= 1){
                        clearInterval(autoLogoutInterval);
                        clearInterval(logoutWarningInterval);
                        $.ajax({
                            url: $(SESSION_TIMEOUT_MODAL_ID).data('logout'),
                            type: 'get',
                            success: function () {
                                if ($('#checkout-main').length) {
                                    localStorage.setItem('openSessionSignInModal', true);
                                    window.location.href = $(SESSION_TIMEOUT_MODAL_ID).data('homeurl');
                                } else {
                                    $('body').trigger('signinModal:open', [$(SESSION_TIMEOUT_MODAL_ID).data('login'), null, true]);
                                }
                            }
                        });
                    }
                },1000);
            }
        }

        function hideSessionTimeoutModal() {
            if ($(SESSION_TIMEOUT_MODAL_ID).is(':visible')) {
                $(SESSION_TIMEOUT_MODAL_ID).modal('hide');
                clearInterval(autoLogoutInterval);
            }
        }

        // Update shared activity timestamp
        function updateActivity() {
            localStorage.setItem(LAST_ACTIVITY_KEY, Date.now());
            hideSessionTimeoutModal();
        }

        // reset session timeout timer
        $(document).on('keydown click', function() {
            if (!$(SESSION_TIMEOUT_MODAL_ID).is(':visible') && !$(SIGNIN_MODAL_ID).is(':visible')) {
                updateActivity();
            }
        });
        $('.stay-signed-in, #sessionTimeoutModal .close').on('click', function () {
            updateActivity();
        });

        // Cross-tab listener: reset if activity happens in another tab
        window.addEventListener('storage', function (event) {
            if (event.key === LAST_ACTIVITY_KEY) {
                hideSessionTimeoutModal();
            }
        });

        // Periodically check for inactivity
        logoutWarningInterval = setInterval(function () {
            var last = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY), 10) || Date.now();
            var inactiveTime = Date.now() - last;

            if (inactiveTime >= sessionTimeoutTime) {
                showSessionTimeoutModal();
            } else {
                hideSessionTimeoutModal();
            }
        }, 10000);

        updateActivity();
    }
};
